import { fromJS } from 'immutable';
import { DISCARD_FROM_PLAY, END_DISCARD_FROM_PLAY, END_LOOK, LOOK } from './constants';

/** @param {List} deckPositions the cards picked from the deck, in order */
export const look = (deckPositions) => ({
  type: LOOK,
  payload: fromJS({ deckPositions }),
});

export const endLook = () => ({
  type: END_LOOK,
});

/** @param {string|number} at where the Trainer in play is: 'active' or a bench position */
export const discardFromPlay = (at) => ({
  type: DISCARD_FROM_PLAY,
  payload: fromJS({ at }),
});

export const endDiscardFromPlay = () => ({
  type: END_DISCARD_FROM_PLAY,
});
